// Cómo se acomoda el núcleo de carga compacto según lo que mide su recuadro —
// ADR-2026-10-05-el-recuadro-de-carga-se-acomoda-a-su-tamano.
//
// El mismo recuadro vive en la columna de un modo, en una card del chat, en Creaciones
// y en una celda del lienzo, con la proporción del formato pedido: un 4:5 en el chat
// mide 264×330 y un 16:9 en una grilla de tres, 225×127. Apilar animación, título y
// barra pide ~150 px de alto; en un recuadro bajo el texto se montaba sobre la barra o
// se cortaba. Puro, para testearlo.

export type DisposicionDeCarga = 'columna' | 'fila' | 'minima';

/** Lo que necesita la pila animación + título + barra (+ nota del video). */
export const ALTO_MINIMO_COLUMNA = 150;
/** "Generando video…" a 13 px, con aire. */
export const ANCHO_MINIMO_COLUMNA = 110;
/** La animación al costado más el texto y la barra al lado. */
export const ANCHO_MINIMO_FILA = 200;
export const ALTO_MINIMO_FILA = 72;

export function disposicionDeCarga(ancho: number, alto: number): DisposicionDeCarga {
  // Sin medida (primer render, o sin `ResizeObserver`): la columna de siempre.
  if (!(ancho > 0) || !(alto > 0)) return 'columna';
  if (alto >= ALTO_MINIMO_COLUMNA && ancho >= ANCHO_MINIMO_COLUMNA) return 'columna';
  if (ancho >= ANCHO_MINIMO_FILA && alto >= ALTO_MINIMO_FILA) return 'fila';
  return 'minima';
}
